function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.5 6.66667H2.66667C4.0668 6.66667 4.76686 6.66667 5.30164 6.39418C5.77205 6.1545 6.1545 5.77205 6.39418 5.30164C6.66667 4.76686 6.66667 4.0668 6.66667 2.66667V2.5M2.5 13.3333H2.66667C4.0668 13.3333 4.76686 13.3333 5.30164 13.6058C5.77205 13.8455 6.1545 14.228 6.39418 14.6984C6.66667 15.2331 6.66667 15.9332 6.66667 17.3333V17.5M13.3333 2.5V2.66667C13.3333 4.0668 13.3333 4.76686 13.6058 5.30164C13.8455 5.77205 14.228 6.1545 14.6984 6.39418C15.2331 6.66667 15.9332 6.66667 17.3333 6.66667H17.5M13.3333 17.5V17.3333C13.3333 15.9332 13.3333 15.2331 13.6058 14.6984C13.8455 14.228 14.228 13.8455 14.6984 13.6058C15.2331 13.3333 15.9332 13.3333 17.3333 13.3333H17.5",
  stroke: "#111927",
  strokeWidth: 1.66667,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgMinimize02(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimize02);
export default __webpack_public_path__ + "static/media/minimize-02.36d50185.svg";
export { ForwardRef as ReactComponent };